import React, {Fragment, useEffect, useState} from "react";
import axios from "axios";
import {accountService} from "./Account.service";
import Table from "react-bootstrap/Table";
import button from "bootstrap/js/src/button";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";


accountService.isLoggedRedirect();
function Stats() {

    const mytoken = JSON.parse(localStorage.getItem('token')).token;
    const config = {headers: { Authorization: `Bearer ${mytoken}` } };
    const [stats, setDataStats] =  useState([]);
    const [statsbyip, setStatsByIp] = useState([]);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const getStats = async async => {
        axios.get(process.env.REACT_APP_API_URLSF + `/api/users/stats`, config)
            .then(data => {
                    setDataStats(data.data);
                    console.log(data.data);
                }
            ).catch(err => console.error(err));
    }

    useEffect(() => {
            getStats()
    }, [])

    const getStatsById = async (ip) => {
        handleShow();
        setStatsByIp([]);
        const response = await fetch(process.env.REACT_APP_API_URLSF +`/api/users/stats/`+ip, config);
        const data = await response.json();
        setStatsByIp(data);
        console.log(data)
        // const getinfos = clickInfos.getUserIp();
        //clickInfos.getUserIp('blog');
    };

    const GenerateStats = async async => {
        const response = await fetch(process.env.REACT_APP_API_URLSF +`/api/fill/stats/`, config);
        const Statsdatas = await response.json();
        if(Statsdatas.result !== ''){
            alert(Statsdatas.result)
        }
        setDataStats([]);
        getStats();
    }
    return (

        <Fragment>
            <section id="signup" className="signup-section">

                <div className="container">
                    <Button className="btn btn-danger btn-sm justify-content-center" type="submit" onClick={() => GenerateStats()}>Générer les stats</Button>
                    <div className="align-self-center">
                        <Table bordered hover size="sm" striped="columns">
                            <thead>
                            <tr>
                                <th>ip de cette personne</th>
                                <th>dernière route utilisée</th>
                                <th>Total clics effectués</th>
                            </tr>
                            </thead>
                            <tbody>
                            {stats.map((item) => (

                                <tr key={item.id}>
                                    <th><button className="dropdown-item" onClick={() => getStatsById(item.ip)}>{item.ip}</button></th>
                                    <th>{item.lastroute}</th>
                                    <th>{item.count}</th>
                                </tr>


                            ))
                            }
                            </tbody>
                        </Table>
                    </div>
                </div>
            </section>
            <Modal show={show} onHide={handleClose} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton  className="modalopacity">
                    <Modal.Title>Statistiques</Modal.Title>
                    <button  className="btn btn-danger btn-sm justify-content-center" >Interdire cette ip</button>
                </Modal.Header>
                <Modal.Body class='modal-body-disabled'>
                    <Table striped bordered hover>
                    <thead>
                    <tr>
                        <th>Date</th>
                        <th>ip de cette personne</th>
                        <th>routes utilisées</th>
                        <th>Total clics effectués</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                        {statsbyip.map((statforuser) => (
                        <tr key={statforuser.ip}>
                            <th key={statforuser.ip}>{statforuser.month}</th>
                            <th key={statforuser.ip}>{statforuser.ip}</th>
                            <th key={statforuser.ip}>{statforuser.route}</th>
                            <th key={statforuser.ip}>{statforuser.count}</th>
                            <th key={statforuser.ip}>{statforuser.service}</th>
                        </tr>
                    ))
                    }
                    </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer className="modalopacity">
                    <Button onClick={handleClose}>Close</Button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    )
}
export default Stats;